import React from 'react';
import { DialogUI } from '../Interface';
import { Grid, Box, Typography } from '@mui/material';
import { sxConfig } from './jobmonitor.style';

const ButtonDialog = ({ dialogData, handleClose }) => {
  const { open, headerContent, buttons, onClick } = dialogData;

  return (
    <DialogUI open={open} onClose={handleClose} headerContent={headerContent} fullWidth={true} maxWidth="sm">
      <Grid container spacing={0.2} pt={2}>
        {buttons.length > 0 &&
          buttons.map((button) => (
            <Grid item xs={6} p={1} key={button.id}>
              <Box onClick={() => onClick(button)} sx={sxConfig.buttonDialogBox}>
                <Typography sx={sxConfig.buttonDialogTypography1}>{button.code}</Typography>
                <Typography sx={{ fontSize: button.code ? '0.85rem' : '1.5rem', ...sxConfig.buttonDialogTypography2 }}>
                  {button.name}
                </Typography>
              </Box>
            </Grid>
          ))}
      </Grid>
    </DialogUI>
  );
};

export default ButtonDialog;
